export default "__VITE_ASSET__786Am8Tt__"